import * as React from 'react';
import { Card } from 'antd';
import cl from 'classnames';

import { Media, MediaProps } from '../components/Media/Media';
import styled from 'styled-components';

const Main = styled.div`
  .baseCard {
    display: flex;
    flex-direction: column;
    height: 100%;
    border-color: #e9eaeb;
    background-color: transparent;
  }
  .baseCard.rounded {
    border-radius: 8px;
  }
  .baseCard.horizontal {
    flex-direction: row;
  }
  .baseCard.horizontal.rtl {
    flex-direction: row-reverse;
  }
  .baseCard:global(.ant-card-hoverable):hover {
    box-shadow: 0 16px 24px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.04),
      0 0 1px rgba(0, 0, 0, 0.04);
  }
  .baseCard :global(.ant-card-body) {
    flex: 1;
  }
`;

export interface MediaModel extends Omit<MediaProps, 'url'> {}

export interface BaseCardProps {
  className?: string;
  children?: React.ReactNode;
  directional?: 'vertical' | 'horizontal';
  media?: MediaModel;
  url?: string;
  bordered?: boolean;
  hoverable?: boolean;
  rounded?: boolean;
  rtl?: boolean;
}

export const BaseCard = (props: BaseCardProps) => {
  const {
    className,
    children,
    directional = 'vertical',
    media,
    url,
    bordered = false,
    hoverable = false,
    rounded = false,
    rtl = false,
  } = props;
  const withMedia = Boolean(media);

  return (
    <Main>
      <Card
        className={cl('baseCard', directional, className, {
          rtl: rtl,
          rounded: rounded,
          'directional-horizontal': directional === 'horizontal',
        })}
        bodyStyle={{ padding: 0 }}
        cover={withMedia && <Media url={url} {...media} />}
        hoverable={hoverable}
        bordered={bordered}
      >
        {children}
      </Card>
    </Main>
  );
};
